var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLandArea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6 3H3V6.6H6.6V3Z",
    stroke: "#A09B97",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0004 17.4001H17.4004V21.0001H21.0004V17.4001Z",
    stroke: "#A09B97",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6 17.4001H3V21.0001H6.6V17.4001Z",
    stroke: "#A09B97",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0004 3H17.4004V6.6H21.0004V3Z",
    stroke: "#A09B97",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.7998 17.4001V6.6001",
    stroke: "#A09B97",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.5 2.5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2002 17.4001V6.6001",
    stroke: "#A09B97",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.5 2.5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6001 4.80005H17.4001",
    stroke: "#A09B97",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.5 2.5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6001 19.2H17.4001",
    stroke: "#A09B97",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.5 2.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandArea);
export default __webpack_public_path__ + "static/media/land_area.76d5c03cb4a1839372e75d5a3266fdfc.svg";
export { ForwardRef as ReactComponent };